import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from "@angular/core";
import { ITaskProduct } from "../task.interface";
import { Observable, debounceTime, distinctUntilChanged, of, startWith, switchMap } from "rxjs";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { FormControl } from "@angular/forms";
import { AuthService } from "../../../../shared/services/auth.service";
import { ProductsService } from "../../../products-page/products/products.service";
import { IProduct } from "../../../products-page/products/products.interface";
import { ProductsModalComponent } from "../../../products-page/products/products-modal/products-modal.component";

let self: any;

@Component({
  selector: 'app-task-modal-products',
  templateUrl: './task-modal-products.component.html',
  styleUrls: ['./task-modal-products.component.css']
})
export class TaskModalProductsComponent implements OnInit {
  @Input('products') productItems: ITaskProduct[] = [];
  @Input('readOnly') readOnly: boolean = true;
  @Input('tax') tax: number = 0;
  @Input('taxPercentage') taxPercentage: number = 0;
  @Input('status') status: string = "";
  @Output('totals') onTotals = new EventEmitter<any>();
  @Output('changes') changes = new EventEmitter<any>();

  myControl = new FormControl();
  $products: Observable<any> = of();
  totals = { total: 0, subtotal: 0, tax: 0, taxPercentage: 0 }
  curr!: string;

  constructor(
    private _AuthService: AuthService,
    private _viewContainerRef: ViewContainerRef,
    public _ProductsService: ProductsService,
    private _dialog: MatDialog,
    private ref: ChangeDetectorRef
  ) {
    self = this;
  }

  ngOnInit(): void {
    this.curr = this._AuthService.currency();
    this.calculateTotals();
    this.$products = this.myControl.valueChanges
      .pipe(
        startWith(''),
        debounceTime(100),
        distinctUntilChanged(),
        switchMap(val => {
          // if ((val || '').length < 1) return of([]);
          return this.filterProducts(val || '')
        })
      );
  }

  filterProducts(item: string | IProduct): Observable<any[]> {
    let filter: any = {
      sort: 'name',
      skip: 0,
      limit: 5000,
      company: this._AuthService.companyId()
    };
    filter.filters = { isDeleted: false };
    if (item) filter.filters.name = item;
    return this._ProductsService.getProducts(filter);
  }

  openNewProductModal() {
    let config = new MatDialogConfig();
    config.width = '400px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(ProductsModalComponent, config);
    self.dialogRef.componentInstance.product = {};
    self.dialogRef.componentInstance.readOnly = false;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      // if (result) this.newProductSelected(result);
    });
  }

  cambio(event: any) {
    console.log(event)
  }

  newProduct() {
    let user = this._AuthService.profile();
    this.productItems.push({
      name: "",
      cost: 0,
      price: 0,
      quantity: 1,
      subtotal: 0,
      taxPercentage: 21,
      tax: 0,
      total: 0,
      addBy: "admin",
    })
  }

  newProductSelected(item: any, itemSelected: any) {
    let user = this._AuthService.profile();
    this.myControl.setValue(null);

    item.product = itemSelected;
    item.name = itemSelected.name;
    item.cost = itemSelected.cost;
    item.price = itemSelected.price;
    item.quantity = 1;
    item.addBy = itemSelected.addBy ?? "admin";
    console.log(item);
    // item.addByUser = user.id;
    // item.tax = (item.price*item.quantity) * (item.taxPercentage * 0.01)
    this.calculateSubTotals(item);
    this.calculateTotals();
    this.changes.emit(true);

  }

  decrementItem(item: ITaskProduct) {
    if (!item.quantity) item.quantity = 0;
    item.quantity--;
    if (item.quantity < 0) item.quantity = 0;
    this.calculateTotals();
    this.changes.emit(true);
  }

  incrementItem(item: ITaskProduct) {
    if (!item.quantity) item.quantity = 0;
    item.quantity++;
    this.calculateTotals();
    this.changes.emit(true);
  }

  removeItem(item: ITaskProduct) {
    const index = this.productItems.indexOf(item);
    this.productItems.splice(index, 1);
    this.calculateTotals();
    this.changes.emit(true);
  }

  taxPercentageChanged(event: any) {
    if (this.taxPercentage < 0) {
      this.taxPercentage = 0;
    }
    this.taxPercentage = event;
    this.calculateTotals();
    this.changes.emit(true);
  }

  onNameInputChange(item: any, newName: string) {
    if (item && item.product) {
      item.name = newName;
      this.productItems = [...this.productItems];
    }
    this.changes.emit(true);
  }

  onQuantityChange(item: ITaskProduct, event: any) {
    item.quantity = event;
    this.calculateSubTotals(item);
    this.calculateTotals();
    this.changes.emit(true);
  }

  onUnitPriceChange(item: ITaskProduct, event: any) {
    item.price = event;
    this.calculateSubTotals(item);
    this.calculateTotals();
    this.changes.emit(true);
  }

  calculateSubTotals(item: any) {
    item.subtotal = item.quantity * item.price;
    item.tax = (item.quantity * item.price) * (item.taxPercentage * 0.01);
    item.total = item.subtotal + item.tax
  }

  calculateTotals() {
    try { this.totals.subtotal = this.productItems.map((el: any) => el.price * el.quantity).reduce((sum, val) => sum + val) || 0; }
    catch (e) { this.totals.subtotal = 0 }

    this.totals.taxPercentage = this.taxPercentage;
    try { this.totals.tax = this.totals.subtotal * this.totals.taxPercentage / 100 }
    catch (e) { this.totals.tax = 0 }

    this.totals.total = this.totals.subtotal + this.totals.tax;
    this.onTotals.emit(this.totals);
  }
}